module.exports = __webpack_public_path__ + "0a6d5458433459e1146128aab77b847d.jpg";